<div class="branded-asset-cover">
	<div class="middle">
		<div class="floating-entry">
			<div class="branded-asset-logo"></div>
			<table *ngIf="brand.poweredBy" class="powered-table">
				<tr>
					<td>Powered by</td>
					<td>
						<a href="https://www.gpms-vt.com/" class="branded-asset-poweredby"></a>
					</td>
				</tr>
			</table>
		</div>
		<div class="floating-entry">
			<div class="input-bounder">
				<form (ngSubmit)="Login()">
					<div *ngIf="!brand.localCloud" class="form-group">
						<label for="email">Email address</label>
						<input [(ngModel)]="email" name="email" type="email" id="email" class="form-control">
					</div>
					<div *ngIf="brand.localCloud" class="form-group">
						<label for="email">User name</label>
						<input [(ngModel)]="email" name="email" type="text" id="email" class="form-control">
					</div>
					<div class="form-group">
						<label for="password">Password</label>
						<input [(ngModel)]="password" name="password" type="password" id="password" class="form-control">
					</div>
					<div class="form-group">
						<button type="submit" class="btn btn-success">Log In</button>
					</div>
				</form>
				<div *ngIf="errormessage" class="message-bad">{{errormessage}}</div>
				<div *ngIf="!brand.localCloud" class="forgot-link">
					<a [routerLink]="['/forgot']">Forgot password?</a>
				</div>
			</div>
		</div>
	</div>
</div>